import React from 'react';
import { TextField, Box, Typography } from '@mui/material';
import { Question } from '../../types';

interface FreeResponseQuestionProps {
  question: Question;
  value: string;
  onChange: (value: string) => void;
  label?: string;
  hideTitle?: boolean;
}

export const FreeResponseQuestion: React.FC<FreeResponseQuestionProps> = ({
  question,
  value,
  onChange,
  label,
  hideTitle = false
}) => {
  return (
    <Box>
      <TextField
        fullWidth
        multiline
        rows={4}
        variant="outlined"
        label={label || "Your response"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        margin="normal"
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'background.paper',
            borderRadius: 2,
          }
        }}
      />
    </Box>
  );
};